import * as React from 'react';

import ContentHubButton from '@/components/content-hub-button/content-hub-button';
import { COLORS, SIZES } from '@/components/content-hub-button/content-hub-button.constants';
import { ContentHubUrlPrefix, replaceOrAddLocale, useLocale } from '@/helpers/LangHelper';
import { ArticleAuthor } from '@/types/ArticleAuthor';

import styles from './article-bio-block.module.scss';
import IconAuthorAvatar from './IconAuthorAvatar';
interface Props {
  articleAuthor: ArticleAuthor | undefined;
}
const ArticleBioBlock = (props: Props) => {
  const { locale } = useLocale();
  const { articleAuthor } = props;
  const renderAuthorAvatar = () => {
    if (!articleAuthor?.leadImage || articleAuthor?.leadImage === '') {
      return <IconAuthorAvatar />;
    }
    return (
      <div
        className={styles.articleLeadImage}
        style={{ backgroundImage: `url('${articleAuthor?.leadImage}')` }}
      />
    );
  };

  return (
    <div className={styles.articleBioContainer}>
      <div className={styles.articleAuthorAvatar}>{renderAuthorAvatar()}</div>
      <div className={styles.articleInfo}>
        <span className={styles.writtenBy}>Written by</span>
        <div className={styles.name}>{articleAuthor?.name}</div>
        <div className={styles.bio}>{articleAuthor?.bio}</div>
      </div>
      <div className={styles.articleLink}>
        <ContentHubButton
          link={replaceOrAddLocale(`/${ContentHubUrlPrefix.TheLoop}`, locale)}
          buttonText="More Articles"
          color={COLORS.BLACK}
          size={SIZES.SMALL}
        />
      </div>
    </div>
  );
};

export default ArticleBioBlock;
